import {getCookie} from '../Utility/CookieUtility';

// @todo: add new countries here:
export const availableCountries = ['de', 'ch', 'at', 'fr', 'be', 'nl', 'lu', 'cn', 'sg', 'it', 'kn', 'ca', 'us', 'mx', 'pr', 'si', 'pl', 'th', 'my'];

export function getCountryCode(): string {
  let $body = $('body');
  const bodyElement = $body[0];
  let country = $body.data('country') || '';
  if (!country) {
    country = getCookieCountryCode();
    // country not found in cookie or in availableCountries
    if (country === '' || $.inArray(country, availableCountries) === -1) {
      country = getBrowserLanguageCode();
    }
    bodyElement.classList.add('country-' + country);
    $body.data('country', country);
  }
  return country;
}

export function isCountryInNorthAmerica(): boolean {
  return ['mx', 'pr', 'ca', 'us'].includes(getCountryCode());
}

function getBrowserLanguageCode(): string {
  let code = String(navigator.language || (<any>navigator).userLanguage || (<any>navigator).systemLanguage).toLowerCase();
  if (code.length === 5 && code.substr(2, 1) === '-') {
    code = code.substr(3, 2);
  }
  if (code.length !== 2) {
    code = '';
  }
  return code;
}

/**
 * The cookie country code was set by apache-server (based on GeoIP https://dev.maxmind.com/geoip/geoip2/geolite2/)
 */
function getCookieCountryCode(): string {
  return getCookie('visitor_country').toLowerCase();
}
